import { CellContext } from '@tanstack/react-table';
import { TourStatus } from '@/features/dashboard/tours/types/TourStatus.ts';
import { tourStatusUtils } from '@/features/dashboard/tours/types/TourStatus.utils.ts';
import { StatusDot } from '@/components/ui/StatusDot.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';

export const tourStatusFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const status = info.getValue() as TourStatus;
  const config = tourStatusUtils.getConfig(status);
  if (!config) return <EmptyValue />;

  return (
    <Tooltip>
      {/* StatusDot nie przekazuje dalej refa, więc `asChild` potrzebuje własnego elementu. */}
      <TooltipTrigger asChild>
        <span className="inline-flex max-w-full cursor-default">
          <StatusDot label={config.label} tone={config.tone} />
        </span>
      </TooltipTrigger>
      <TooltipContent>{tourStatusUtils.getTooltip(status)}</TooltipContent>
    </Tooltip>
  );
};
